export default class BulletsAnimation {
	constructor(containerSelector, id, bulletsClasses, count = 10, clockPeriodMs = 100) {
		this.containerSelector = containerSelector;
		this.bulletsClasses = bulletsClasses;
		this.id = id;
		this.count = count;
		this.clockPeriodMs = clockPeriodMs;
	}

	createAndRun(backward = false, containerLayerOverride = null) {
		const jOverlayLayer = $(containerLayerOverride || this.containerSelector);
		if (jOverlayLayer && jOverlayLayer.length) {
			const jBullets = jOverlayLayer.find(`#${this.id}`);
			if (!jBullets || !jBullets.length) {
				const bullet4Animation = this.createBullets(this.count);
				jOverlayLayer[0].appendChild(bullet4Animation);
			} else {
				jBullets.removeClass('inactive');
			}
			if (backward) this.startReloadingSpinnerBack();
			else this.startReloadingSpinner();
		}
	}

	createBullets(count) {
		// this.bulletCount = count;
		const bulletsLayer = document.createElement('div');
		$(bulletsLayer).addClass(this.bulletsClasses.join(' '));
		bulletsLayer.id = this.id;
		bulletsLayer.style.opacity = 0;
		bulletsLayer.style.display = 'block';

		const ulContainer = document.createElement('ul');
		for (let i = 0; i < count; i++) {
			const innerLi = document.createElement('li');
			const anchorLink = document.createElement('div');
			innerLi.appendChild(anchorLink);
			ulContainer.appendChild(innerLi);
		}
		bulletsLayer.appendChild(ulContainer);
		bulletsLayer.style.opacity = 1;
		return bulletsLayer;
	}

	activateBullet(idx) {
		$(`#${this.id} li > div`).removeClass('active');
		$(`#${this.id} li > div`).removeClass('semi-active');
		$(`#${this.id} li:nth-child(${idx}) > div`).addClass('active semi-active');
		$(`#${this.id} li:nth-child(${idx - 1}) > div`).addClass('active');
		$(`#${this.id} li:nth-child(${idx - 2}) > div`).addClass('active semi-active');
	}

	destroy() {
		$(`#${this.id}`).addClass('inactive');
		$(`#${this.id} li > div`).removeClass('active');
		$(`#${this.id} li > div`).removeClass('semi-active');
		this.bulletHideTimeout = setTimeout(() => {
			if (this.spinnerInterval) clearInterval(this.spinnerInterval);
		}, 1000);
	}

	startReloadingSpinner() {
		let idx = 0;
		if (this.spinnerInterval) clearInterval(this.spinnerInterval);
		if (this.bulletHideTimeout) clearTimeout(this.bulletHideTimeout);
		this.spinnerInterval = setInterval(() => {
			this.activateBullet(idx);
			idx++;
			if (idx > this.count + 2) idx = 0;
		}, this.clockPeriodMs);
	}

	startReloadingSpinnerBack() {
		if (this.spinnerInterval) clearInterval(this.spinnerInterval);
		if (this.bulletHideTimeout) clearTimeout(this.bulletHideTimeout);
		let idx = this.count + 2;
		this.spinnerInterval = setInterval(() => {
			this.activateBullet(idx);
			idx--;
			if (idx < 0) idx = this.count + 2;
		}, this.clockPeriodMs);
	}
}
